<template>
  <div class="d-flex flex-column ga-8">
    <v-select v-model="selectedYear" :items="years" density="compact" hide-details variant="solo" />

    <div class="">
      <div class="d-flex align-center justify-space-between">
        <p>{{ $t('maand') }}</p>
        <p>{{ $t('gebruikt-totaal') }}</p>
      </div>

      <div v-if="loading" class="d-flex flex-column ga-4 mt-6">
        <div v-for="i in 4" :key="i" class="">
          <v-skeleton-loader type="list-item" />
        </div>
      </div>

      <div v-else class="d-flex flex-column ga-4 mt-6">
        <div v-for="(credit, index) in credits" :key="index" class="">
          <div class="d-flex align-center justify-space-between">
            <p class="text-bold text-capitalize">{{ new Date(selectedYear, credit.month_index).toLocaleDateString(this.$i18n.locale, { month: 'long' }) }}</p>
            <p>{{ credit.credits }}/{{ max }}</p>
          </div>

          <v-progress-linear class="rounded-sm" :max="max" :model-value="credit.credits" color="var(--company-primary)"></v-progress-linear>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import CreditsService from "../../../services/CreditsService";

export default {
  data() {
    return {
      selectedYear: null,
      loading: true,

      credits: [],
    };
  },

  props: {
    max: {
      type: Number,
      required: true,
    }
  },

  mounted() {
    this.selectedYear = new Date().getFullYear();
    this.getCredits();
  },

  computed: {
    years() {
      const currentYear = new Date().getFullYear();

      // make an array of this year and the next 3 years
      const years = [];
      for (let i = 0; i < 4; i++) {
        years.push(currentYear + i);
      }
      return years;
    },

    months() {
      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth(); // getMonth() returns 0-11

      // If selected year is current year, return current month + remaining months
      if (this.selectedYear === currentYear) {
        const months = [];
        for (let i = currentMonth; i < 12; i++) {
          const monthName = new Date(2025, i).toLocaleDateString(this.$i18n.locale, { month: 'long' });
          months.push({ month: monthName });
        }
        return months;
      }

      // For other years, return all 12 months
      const months = [];
      for (let i = 0; i < 12; i++) {
        const monthName = new Date(2025, i).toLocaleDateString(this.$i18n.locale, { month: 'long' });
        months.push({ month: monthName });
      }
      return months;
    },
  },

  methods: {
    async getCredits() {
      try {
        this.loading = true;
        const response = await CreditsService.getMonthlyCredits(this.selectedYear);

        if (response) {
          this.credits = response.data.data;
          this.loading = false;
        }
      } catch (error) {
        console.error("Error getting credits", error);
        this.$toast.error("Er is iets fout gegaan bij het ophalen van de credits");
      }
    }
  },

  watch: {
    selectedYear() {
      this.getCredits();
    }
  }
};
</script>
